//#region stateSection
import { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { useTranslation } from "react-i18next";
import { IoArrowBackSharp } from "react-icons/io5";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import Select from "react-select";
import { Button, Col, FormGroup, Input, Label, Row } from "reactstrap";
import swal from "sweetalert";
import {
  CheckPermission,
  LoadingSpinner,
  convertToDateString,
  customOption,
  customSingleValue,
} from "../../constants/const";
import { encryptStorage } from "../../constants/EncryptStorage";
import SearchAutoComplete from "../shared/SearchAutoComplete";
import { ApiFinance } from "../config/finance/ApiFinance";
import { ApiFund } from "./ApiFund";
import { addMember } from "../member/ApiMember";
import { GetLanguageString } from "../helper/Components";
import { GetCustomStyles, GetSelectedLanguage } from "../helper/Method";
import SelectUnit from "../shared/SelectUnit";
//#endregion stateSection
const AddInfaqAmanatAccount = ({ history }) => {
  //#region stateDeclare
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const [serverError, setServerError] = useState("");
  const loggedInUnitId = parseInt(encryptStorage.getItem("loggedInUnitId"));
  const [members, setMembers] = useState([]);
  const [selectedMember, setSelectedMember] = useState(null);
  const [recipientType, setRecipientType] = useState("rafiq"); // 'rafiq' | 'registered' | 'unregistered'
  const [ahbabOptions, setAhbabOptions] = useState([]);
  const [selectedHabib, setSelectedHabib] = useState(null);
  const [unregisteredHabibName, setUnregisteredHabibName] = useState("");
  const [values, setValues] = useState({
    unit: { value: loggedInUnitId, lable: "" },
    includeSubUnit: false,
  });
  const unitId = values.unit.value;
  const [errors, setErrors] = useState({ selectedMember: "" });
  const fieldColSize = 3; // uniform column size for form fields
  let membersList = [];
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [fundValues, setFundValues] = useState({});
  const [infaqHeads, setInfaqHeads] = useState([]);
  const [selectedInfaqHead, setSelectedInfaqHead] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [memberId, setMemberId] = useState(0);
  // //#region useEffectSection
  useEffect(() => {
    let currentDate = new Date();
    let tempYear = currentDate.getFullYear();
    let tempMonth = currentDate.getMonth() + 1;
    setFundValues({
      memberId:
        recipientType === "rafiq"
          ? selectedMember?.value || null
          : recipientType === "registered"
            ? memberId || null
            : null,
      name:
        recipientType === "rafiq"
          ? selectedMember?.label || ""
          : recipientType === "registered"
            ? selectedHabib || ""
            : unregisteredHabibName || "",
      includeSubUnit: values.includeSubUnit || false,
      unitId: unitId,
      date: currentDate,
      month: tempMonth,
      year: tempYear,
      receiptNumber: "",
      amount: null,
      codeId: selectedInfaqHead?.value,
    });
  }, [
    unitId,
    selectedMember,
    selectedInfaqHead,
    recipientType,
    selectedHabib,
    unregisteredHabibName,
    values.includeSubUnit,
    memberId,
  ]);
  useEffect(() => {
    setLoading(true);
    ApiFinance()
      .GetInfaqHeadsList()
      .then((res) => {
        if (res?.data) {
          setInfaqHeads(res.data); // default select first one
          if (res.data.length > 0) {
            setSelectedInfaqHead(res.data[0]);
            setFundValues((prev) => ({ ...prev, codeId: res.data[0].value }));
          }
          setLoading(false);
        }
      })
      .catch((err) => {
        swal({ title: err, icon: "error", buttons: "OK" });
        console.error(err);
      });
  }, []);
  useEffect(() => {
    addMember()
      .getUnitMembersForSelecting(values.unit.value, values.includeSubUnit)
      .then((res) => {
        setMembers(res.data);
        if (res.data.length !== 0) {
          setSelectedMember({
            value: res.data[0].id,
            label: res.data[0].name + " - " + res.data[0].regNo,
          });
          setErrors({ member: "" });
        } else {
          setSelectedMember({});
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, [values]);

  useEffect(() => {
    if (selectedHabib && !selectedHabib.includes("/")) {
      setLoadingSearch(true);

      const timeoutId = setTimeout(() => {
        addMember()
          .getUnitParticipantsByType(
            values.unit.value,
            values.includeSubUnit,
            "habib",
            selectedHabib,
          )
          .then((res) => {
            if (res.data) {
              setAhbabOptions(res.data);
            }
            setLoadingSearch(false);
          })
          .catch((err) => {
            swal({ title: err, icon: "error", buttons: "OK" });
            console.error(err);
            setLoadingSearch(false);
          });
      }, 1000);

      return () => clearTimeout(timeoutId);
    }
  }, [selectedHabib, values]);
  //#endregion useEffectSection
  const handleInfaqHeadChange = (selected) => {
    setSelectedInfaqHead(selected);
    setFundValues((prev) => ({
      ...prev,
      codeId: selected ? selected.value : "",
    }));
    setErrors((prev) => ({
      ...prev,
      selectedInfaqHeadErrorMsg: selected
        ? ""
        : "Please select an Account Head",
    }));
  };
  //#region functionHandler
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const maxSize = 1 * 1024 * 1024; // 1MB

    if (file.size > maxSize) {
      setErrors((prev) => ({ ...prev, file: "File must be under 1MB" }));
      setUploadedFile(null);
    } else {
      setErrors((prev) => ({ ...prev, file: "" }));
      setUploadedFile(file);
    }
  };

  if (members.length !== 0) {
    members.forEach((m) =>
      membersList.push({ value: m.id, label: m.name + " - " + m.regNo }),
    );
  }
  const validate = () => {
    let temp = {};
    temp.month = fundValues.month ? (
      ""
    ) : (
      <GetLanguageString props="funds_add_fund_select_month_error" />
    );
    temp.year = fundValues.year ? (
      ""
    ) : (
      <GetLanguageString props="funds_add_fund_select_year_error" />
    );
    temp.receiptNumber = fundValues.receiptNumber ? (
      ""
    ) : (
      <GetLanguageString props="common_field_required_error" />
    );
    temp.date = selectedDate ? (
      ""
    ) : (
      <GetLanguageString props="funds_add_fund_date_paid_error" />
    );
    temp.amount = fundValues.amount ? (
      ""
    ) : (
      <GetLanguageString props="funds_add_fund_amount_paid_error" />
    );
    if (!uploadedFile) {
      temp.file = "Please upload a deposit slip";
    }
    // Infaq head required only for rafiq flow
    temp.selectedInfaqHeadErrorMsg =
      recipientType === "rafiq" ? (
        selectedInfaqHead ? (
          ""
        ) : (
          <GetLanguageString props="funds_add_fund_account_head_error" />
        )
      ) : (
        ""
      );
    // Validate recipient selection
    if (recipientType === "rafiq") {
      temp.selectedMember =
        selectedMember && selectedMember.value ? (
          ""
        ) : (
          <GetLanguageString props="funds_member_error_message" />
        );
    } else if (recipientType === "registered") {
      temp.selectedHabib =
        selectedHabib && memberId ? (
          ""
        ) : (
          <GetLanguageString props="funds_habib_error_message" />
        );
    } else {
      // unregistered
      temp.unregisteredHabibName = unregisteredHabibName ? (
        ""
      ) : (
        <GetLanguageString props="funds_unregistered_habib_name_error_message" />
      );
    }
    setErrors((prev) => ({ ...prev, ...temp }));
    return Object.values(temp).every((x) => x === "");
  };
  const handleChangeMember = (record) => {
    setSelectedMember(record);
    setErrors((prev) => ({ ...prev, selectedMember: "" }));
  };

  const handleSubUnits = (e) => {
    const { value } = e.target;
    let v = value;
    if (value === "true") v = true;
    else v = false;
    setValues({
      ...values,
      includeSubUnit: v,
    });
  };

  const handleOnSelect = (item) => {
    var str = item?.name;
    let remove = str.split(" - ").pop();
    let requiredName = str.replace(" - " + remove, "   ");
    setSelectedHabib(requiredName + " - " + remove.replace("/", " "));
    setMemberId(item.id);
    setErrors({
      ...errors,
      selectedHabib: "",
    });
    setAhbabOptions([]);
  };
  const handleRecipientTypeChange = (e) => {
    const val = e.target.value;
    setRecipientType(val);
    // reset related fields
    setErrors({});
    if (val === "rafiq") {
      // nothing
    } else if (val === "registered") {
      setSelectedMember(null);
    } else {
      setSelectedMember(null);
      setSelectedHabib(null);
      setUnregisteredHabibName("");
    }
  };

  const handleUnregisteredHabibName = (e) => {
    setUnregisteredHabibName(e.target.value);
    setErrors((prev) => ({ ...prev, unregisteredHabibName: "" }));
  };

  const handleReceiptNumber = (e) => {
    let { value } = e.target;
    value = value.replace(/\D/g, "");
    setFundValues((prev) => ({
      ...prev,
      receiptNumber: value,
    }));
    setErrors((prev) => ({ ...prev, receiptNumber: "" }));
  };
  const handleInputChangeDate = (value) => {
    setSelectedDate(value);
    setErrors((prev) => ({ ...prev, date: "" }));
  };
  const handleAmountChange = (e) => {
    let { value } = e.target;
    value = value.replace(/\D/g, "");
    setFundValues((prev) => ({ ...prev, amount: value }));
    setErrors((prev) => ({
      ...prev,
      amount: "",
    }));
  };
  const handleSubmit = async (addOther = false) => {
    if (!validate()) {
      // validation failed: don't proceed
      return;
    }
    setLoading(true);

    try {
      const formData = new FormData();
      // Determine memberId/person_id/codeId based on recipientType
      if (recipientType === "rafiq") {
        formData.append("memberId", selectedMember?.value ?? null);
        formData.append(
          "codeId",
          selectedInfaqHead?.value ?? fundValues.codeId ?? 0,
        );
        formData.append("isRafiq", true);
      } else if (recipientType === "registered") {
        const regMemberId =
          memberId || (selectedHabib && selectedHabib.value) || "";
        const regName =
          selectedHabib && (selectedHabib.label || selectedHabib.name)
            ? selectedHabib.label || selectedHabib.name
            : typeof selectedHabib === "string"
              ? selectedHabib
              : "";
        formData.append("memberId", regMemberId);
        formData.append(
          "name",
          regName.includes("-")
            ? regName.substring(0, regName.indexOf("-")).trim()
            : regName.trim(),
        );
        formData.append(
          "codeId",
          infaqHeads.find((head) => head.label.includes("Individual"))?.value,
        );
        formData.append("isRafiq", false);
      } else {
        // unregistered
        formData.append("memberId", "");
        formData.append("name", unregisteredHabibName ?? "");
        formData.append(
          "codeId",
          infaqHeads.find((head) => head.label.includes("Individual"))?.value,
        );
        formData.append("isRafiq", false);
      }
      formData.append("unitId", unitId);
      formData.append("date", convertToDateString(selectedDate));
      const monthToSend = selectedDate
        ? selectedDate.getMonth() + 1
        : fundValues.month;
      const yearToSend = selectedDate
        ? selectedDate.getFullYear()
        : fundValues.year;
      formData.append("month", monthToSend);
      formData.append("year", yearToSend);
      formData.append("receiptNumber", fundValues.receiptNumber);
      formData.append("amount", fundValues.amount);
      formData.append("includeSubUnits", fundValues.includeSubUnit || false);
      // Append the file if it exists
      if (uploadedFile) {
        formData.append("file", uploadedFile);
      }
      const res = await ApiFund().addSingleInfaqAmanat(formData);
      // const res = await ApiFund().addSingleInfaqAmanat(payload);
      if (res.data.statusCode === "200") {
        swal({
          title: t("funds_request_forwarded"),
          className: GetSelectedLanguage() === "en" ? "" : "ur",
          icon: "success",
          buttons: "OK",
        });
        if (addOther) {
          // 🔁 reset only necessary fields
          setFundValues((prev) => ({
            ...prev,
            receiptNumber: "",
            amount: "",
          }));
          setSelectedDate(null);
        } else {
          history.goBack();
        }
      } else {
        swal({
          title: t(res.data.message) || t("funds_error_submit_request"),
          className: GetSelectedLanguage() === "en" ? "" : "ur",
          icon: "error",
          buttons: "OK",
        });
        setServerError(res.data.message);
      }
    } catch (err) {
      swal({
        title: err,
        className: GetSelectedLanguage() === "en" ? "" : "ur",
        icon: "error",
        buttons: "OK",
      });
      setServerError(err.response.data);
    } finally {
      setLoading(false);
    }
  };

  //#endregion functionHandler
  return (
    <>
      {serverError && <h4 className="text-danger">{serverError}</h4>}
      <div className="wrapper-custom wrapper wrapper-content animated fadeInRight">
        <div className="ibox ">
          <div className="ibox-title">
            <h5>{<GetLanguageString props="funds_add_fund" />}</h5>
            <Button
              className={GetCustomStyles().btn_style}
              color="white"
              size="xs"
              onClick={() => history.goBack()}
            >
              {" "}
              <IoArrowBackSharp
                color="#18A689"
                size={15}
                style={{ marginRight: 5, marginBottom: 1 }}
              />
              {<GetLanguageString props="courses_participants_back" />}{" "}
            </Button>
          </div>
          <div className="ibox-content">
            {!loading ? (
              <>
                <Row>
                  <SelectUnit
                    values={values}
                    setValues={setValues}
                    unitId={values.unit.value}
                  />
                  <Col md="4">
                    <FormGroup check>
                      <Label check for="subUnit">
                        <Input
                          id="subUnit"
                          type="checkbox"
                          name="includeSubUnit"
                          checked={values.includeSubUnit}
                          value={!values.includeSubUnit}
                          onChange={handleSubUnits}
                        />
                        {
                          <GetLanguageString props="member_search_member_sub_unit" />
                        }
                      </Label>
                    </FormGroup>
                  </Col>
                </Row>
                <hr />
                <Row>
                  <Col md={12}>
                    <FormGroup>
                      <div>
                        <FormGroup check inline>
                          <Label check style={{ marginRight: 24 }}>
                            <Input
                              type="radio"
                              name="recipientType"
                              value="rafiq"
                              checked={recipientType === "rafiq"}
                              onChange={handleRecipientTypeChange}
                            />{" "}
                            {<GetLanguageString props="rafiq" />}
                          </Label>
                        </FormGroup>
                        <FormGroup check inline>
                          <Label check style={{ marginRight: 24 }}>
                            <Input
                              type="radio"
                              name="recipientType"
                              value="registered"
                              checked={recipientType === "registered"}
                              onChange={handleRecipientTypeChange}
                            />{" "}
                            {<GetLanguageString props="registered_habib" />}
                          </Label>
                        </FormGroup>
                        <FormGroup check inline>
                          <Label check style={{ marginRight: 24 }}>
                            <Input
                              type="radio"
                              name="recipientType"
                              value="unregistered"
                              checked={recipientType === "unregistered"}
                              onChange={handleRecipientTypeChange}
                            />{" "}
                            {<GetLanguageString props="unregistered_habib" />}
                          </Label>
                        </FormGroup>
                      </div>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md={fieldColSize}>
                    <FormGroup>
                      {/* Rafiq: existing member select */}
                      {recipientType === "rafiq" && (
                        <>
                          <Label className="col-form-label">
                            {<GetLanguageString props="funds_select_member" />}
                          </Label>
                          <Select
                            components={{
                              Option: customOption,
                              SingleValue: customSingleValue,
                            }}
                            value={selectedMember}
                            options={membersList}
                            className="basic-single ur"
                            classNamePrefix="select"
                            onChange={handleChangeMember}
                          />
                          {errors.selectedMember && (
                            <h4 className="text-error">
                              {
                                <GetLanguageString props="funds_member_error_message" />
                              }
                            </h4>
                          )}
                        </>
                      )}

                      {/* Registered Habib */}
                      {recipientType === "registered" && (
                        <>
                          <Label className="col-form-label">
                            {<GetLanguageString props="member_search_habib" />}
                          </Label>
                          <SearchAutoComplete
                            members={ahbabOptions}
                            setMembers={setAhbabOptions}
                            setName={setSelectedHabib}
                            name={selectedHabib}
                            type={"habib"}
                            loading={loadingSearch}
                            placeholder={t("common_search_by_name")}
                            handleOnSelect={handleOnSelect}
                            calledFrom="mudaris"
                          />
                          {errors.selectedHabib && (
                            <h4 className="text-error">
                              {errors.selectedHabib}
                            </h4>
                          )}
                        </>
                      )}

                      {/* Unregistered Habib */}
                      {recipientType === "unregistered" && (
                        <>
                          <Label className="col-form-label">
                            {<GetLanguageString props="common_name" />}
                          </Label>
                          <Input
                            type="text"
                            value={unregisteredHabibName}
                            onChange={handleUnregisteredHabibName}
                          />
                          {errors.unregisteredHabibName && (
                            <h4 className="text-error">
                              {errors.unregisteredHabibName}
                            </h4>
                          )}
                        </>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md={fieldColSize}>
                    {" "}
                    <FormGroup>
                      {" "}
                      <Label className="col-form-label">
                        {" "}
                        {
                          <GetLanguageString props="funds_add_fund_date_paid" />
                        }{" "}
                      </Label>{" "}
                      <DatePicker
                        minDate={
                          new Date(
                            new Date().getFullYear(),
                            new Date().getMonth(),
                            1,
                          )
                        }
                        maxDate={new Date()}
                        placeholderText="dd/mm/yyyy"
                        className="form-control no-drag"
                        dateFormat="dd/MM/yyyy"
                        selected={selectedDate}
                        onChange={handleInputChangeDate}
                      />
                      {errors.date && (
                        <h4 className="text-error">{errors.date}</h4>
                      )}{" "}
                    </FormGroup>{" "}
                  </Col>{" "}
                  {/* INFAQ HEAD - only for Rafiq flow */}
                  {recipientType === "rafiq" && (
                    <Col md={fieldColSize}>
                      <FormGroup>
                        <Label className="col-form-label">
                          <GetLanguageString props="fund_account_head" />
                        </Label>
                        <Select
                          options={infaqHeads}
                          value={selectedInfaqHead}
                          placeholder="Select infaq head"
                          onChange={handleInfaqHeadChange}
                          className="basic-single no-drag"
                          classNamePrefix="select"
                        />

                        {errors.selectedInfaqHeadErrorMsg && (
                          <h4 className="text-error">
                            {errors.selectedInfaqHeadErrorMsg}
                          </h4>
                        )}
                      </FormGroup>
                    </Col>
                  )}
                  <Col md={fieldColSize}>
                    {" "}
                    <FormGroup>
                      {" "}
                      <Label className="col-form-label">
                        {" "}
                        {
                          <GetLanguageString props="funds_receipt_number" />
                        }{" "}
                      </Label>{" "}
                      <Input
                        autoFocus
                        type="text"
                        className="no-drag"
                        value={fundValues.receiptNumber}
                        onChange={handleReceiptNumber}
                      />{" "}
                      {errors.receiptNumber && (
                        <h4 className="text-error">{errors.receiptNumber}</h4>
                      )}{" "}
                    </FormGroup>{" "}
                  </Col>{" "}
                  {/* Add Amount for the fund */}{" "}
                  <Col md={fieldColSize}>
                    {" "}
                    <FormGroup>
                      {" "}
                      <Label className="col-form-label">
                        {" "}
                        {
                          <GetLanguageString props="funds_add_fund_amount" />
                        }{" "}
                      </Label>{" "}
                      <Input
                        autoFocus
                        type="text"
                        className="no-drag"
                        value={fundValues.amount}
                        onChange={handleAmountChange}
                      />{" "}
                      {errors.amount && (
                        <h4 className="text-error no-drag">{errors.amount}</h4>
                      )}{" "}
                    </FormGroup>{" "}
                  </Col>{" "}
                  <Col md={fieldColSize}>
                    {" "}
                    <FormGroup>
                      {" "}
                      <Label className="col-form-label">
                        {" "}
                        <GetLanguageString props="deposit_slip" />{" "}
                      </Label>{" "}
                      <Input
                        type="file"
                        accept="image/*,application/pdf"
                        name="file"
                        invalid={!!errors.file}
                        onChange={handleFileChange}
                      />{" "}
                      {/* This will now show "Required" OR "File must be under 10MB" */}{" "}
                      {errors.file && (
                        <h4 className="text-error">{errors.file}</h4>
                      )}{" "}
                    </FormGroup>{" "}
                  </Col>{" "}
                </Row>{" "}
                <Row>
                  {" "}
                  <Col md="9"></Col>{" "}
                  <Col md="3" className="text-end">
                    {" "}
                    {CheckPermission("CanAddFunds") ? (
                      <>
                        {" "}
                        <Button color="white" onClick={() => history.goBack()}>
                          {" "}
                          {<GetLanguageString props="common_cancel" />}{" "}
                        </Button>{" "}
                        &nbsp;&nbsp;{" "}
                        <Button
                          color="primary"
                          onClick={() => handleSubmit(false)}
                        >
                          {" "}
                          {<GetLanguageString props="common_save" />}{" "}
                        </Button>{" "}
                        {/* <Button
                          color="success"
                          onClick={() => handleSubmit(true)}
                        >
                          {
                            <GetLanguageString props="funds_add_fund_and_add_other" />
                          }
                        </Button> */}
                      </>
                    ) : null}
                  </Col>
                </Row>
              </>
            ) : (
              LoadingSpinner()
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default withRouter(AddInfaqAmanatAccount);
